import { Controller } from "@hotwired/stimulus"

// Drives the redesigned Select Shipping Address page:
//  - custom radio selection + sticky bar preview + Continue enable/disable
// The Add Address modal is handled by the reusable address-modal controller.
export default class extends Controller {
  static targets = [
    "row", "radio", "circle",
    "stickyName", "stickyAddr", "stickyEmpty", "continueBtn"
  ]

  select(event) {
    const row = event.currentTarget
    const index = this.rowTargets.indexOf(row)
    if (index === -1) return

    this.rowTargets.forEach((r, i) => {
      const on = i === index
      if (this.hasRadioTarget) this.radioTargets[i].checked = on
      r.classList.toggle("sa-row--selected", on)
      this.circleTargets[i].classList.toggle("sa-radio--selected", on)
    })

    const { addressName, addressStreet, addressCityStateZip } = row.dataset
    if (this.hasStickyNameTarget) {
      this.stickyNameTarget.textContent = addressName
      this.stickyNameTarget.classList.remove("sa-hidden")
    }
    if (this.hasStickyAddrTarget) {
      this.stickyAddrTarget.textContent = `${addressStreet} · ${addressCityStateZip}`
      this.stickyAddrTarget.classList.remove("sa-hidden")
    }
    if (this.hasStickyEmptyTarget) this.stickyEmptyTarget.classList.add("sa-hidden")

    if (this.hasContinueBtnTarget) this.continueBtnTarget.disabled = false
  }

  validateSelection(event) {
    const checked = this.hasRadioTarget && this.radioTargets.some(r => r.checked)
    if (!checked) {
      event.preventDefault()
      window.scrollTo({ top: 0 })
      alert("Please select a shipping address.")
    }
  }
}
